/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobLogRequest {
    getFixupPrototypeFunction() { return BackgroundJobLogRequest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobLogRequest>): BackgroundJobLogRequest {
        let obj = Object.assign(new BackgroundJobLogRequest(), model);
        BackgroundJobLogRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobLogRequest>): BackgroundJobLogRequest {
        if (!model) return null;
        return BackgroundJobLogRequest.newInstance(<BackgroundJobLogRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobLogRequest) {
        if (!obj) return;

        models.BackgroundJobLogRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobLogRequest): boolean {
        Object.setPrototypeOf(obj, BackgroundJobLogRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.offset === undefined) {
            this.offset = 0;
        }
        if (this.limit === undefined) {
            this.limit = 0;
        }
        if (this.id) {
            models.RecordIdentity.fixupPrototype(this.id);
        }
    }

    /**
     * The background job to extract the log for
     */
    id: models.RecordIdentity;

    /**
     * First log entry to extract
     */
    offset: number;

    /**
     * Maximum number of log entries to return
     */
    limit: number;

}
